// extracted by mini-css-extract-plugin
module.exports = {"root":"select-field-details_root__3Jqbw"};